(() => {
  'use strict';
  if (!window.customElements || customElements.get('ib-local-money')) return;
  const formats = new Map();
  class IBLocalMoney extends HTMLElement {
    #textObserver;
    #updateQueued = false;

    static get observedAttributes() { return ['data-amount', 'data-currency', 'data-locale']; }

    connectedCallback() {
      this.#textObserver ??= new MutationObserver(() => this.#scheduleUpdate());
      this.#textObserver.observe(this, { childList: true, characterData: true, subtree: true });
      this.update();
    }

    disconnectedCallback() { this.#textObserver?.disconnect(); }

    attributeChangedCallback() { if (this.isConnected) this.#scheduleUpdate(); }

    #scheduleUpdate() {
      if (this.#updateQueued) return;
      this.#updateQueued = true;
      queueMicrotask(() => {
        this.#updateQueued = false;
        if (this.isConnected) this.update();
      });
    }

    update() {
      const raw = this.getAttribute('data-amount');
      const amount = Number(raw);
      const currency = this.getAttribute('data-currency');
      const locale = this.getAttribute('data-locale') || document.documentElement.lang || 'es';
      if (raw === null || raw.trim() === '' || !Number.isFinite(amount) || !currency) return;
      try {
        const key = `${locale}:${currency}`;
        if (!formats.has(key)) formats.set(key, new Intl.NumberFormat(locale, { style: 'currency', currency }));
        const value = formats.get(key).format(amount / 100);
        if (this.textContent !== value) {
          this.textContent = value;
          // The formatter owns this write; discard its own mutation record.
          this.#textObserver?.takeRecords();
        }
      } catch (_) { /* Keep Shopify's native money output when the locale is unsupported. */ }
    }
  }
  customElements.define('ib-local-money', IBLocalMoney);
})();
